import IWizardStep from "components/wizard/interfaces/IWizardStep";
import { TranslationMapper } from "i18n/mapper";
import INotificationCategoryItem from "interfaces/INotificationCategoryItem";
import LanguageProvider from "providers/languageProvider";
import { Component, ReactNode } from "react";
import { Col, Form, Row } from "react-bootstrap";

import INotificationCategoryStepProps from "./interfaces/INotificationCategoryStepProps";
import INotificationCategoryStepState from "./interfaces/INotificationCategoryStepState";
import NotificationValidator from "./notificationValidator";
import IconImageNotFoundInactive from "../../assets/img/image-not-found-inactive.svg";
import IconImageNotFoundActive from "../../assets/img/image-not-found-active.svg";

class NotificationCategoryStep extends Component<INotificationCategoryStepProps, INotificationCategoryStepState> {
  public constructor(props: INotificationCategoryStepProps) {
    super(props);

    const state = this.props.value ?? {
      selectedCategoryId: "",
    };

    this.state = state;

    this.isNotificationCategorySelected = this.isNotificationCategorySelected.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.propagateChange = this.propagateChange.bind(this);
  }

  private selectCategory(category: INotificationCategoryItem): void {
    this.setState((current) => ({ ...current, selectedCategoryId: category.id }), this.propagateChange);
  }

  private propagateChange(): void {
    const isValid = NotificationValidator.isCategoryValid(this.state);
    this.props.onChange({ target: { value: this.state, name: this.props.name }, isValid });
  }

  private isNotificationCategorySelected(notificationCategory: INotificationCategoryItem): boolean {
    return notificationCategory.id === this.state.selectedCategoryId;
  }

  private getCategoryImageUri(notificationCategory: INotificationCategoryItem): string {
    return this.isNotificationCategorySelected(notificationCategory)
      ? `${notificationCategory.imageUri}_Notificationcategory_active`
      : `${notificationCategory.imageUri}_Notificationcategory_inactive`;
  }

  public renderCategories(): JSX.Element {
    return (
      <div className="row category-row">
        {this.props.categories.length > 0 &&
          this.props.categories.map((category, index) => (
            <div
              key={index}
              onClick={(): void => this.selectCategory(category)}
              className={`btn btn--image-label mb-3 ${
                this.isNotificationCategorySelected(category) ? "active" : "inactive"
              }`}
            >
              <img
                src={this.getCategoryImageUri(category)}
                alt="notification category"
                onError={(e): void => {
                  const target = e.currentTarget as HTMLImageElement;
                  target.src = this.isNotificationCategorySelected(category)
                    ? IconImageNotFoundActive
                    : IconImageNotFoundInactive;
                }}
              />
              <div>{category.name}</div>
            </div>
          ))}
      </div>
    );
  }

  public render(): ReactNode {
    return (
      <Form>
        <Row>
          <Form.Group as={Col} sm={12}>
            <Form.Label>{LanguageProvider.t(TranslationMapper.components.notifications.select_category)}</Form.Label>
            {this.renderCategories()}
          </Form.Group>
        </Row>
      </Form>
    );
  }
}

const wizardStep: IWizardStep = {
  form: NotificationCategoryStep,
  titleResource: "",
  name: "category",
};

export default wizardStep;
